/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from "mapbox-gl";
import { motion } from "framer-motion";

import * as Styled from "./styles.js";
import { Heading2, Paragraph, Image } from "../../";
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;
mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2lkZW9uanIiLCJhIjoiY2tudmdlZTZhMDJmYTJvbjRiaHpmcHl3ZyJ9.KxGzrM1ZHq9NwEkXOJz7ZA";

const StoryWithImageAndMap = ({ slideType, duration, ...rest }) => {
  const config = {
    markerColor: "#848",
    location: {
      center: [slideType?.[0]?.longitude, slideType?.[0]?.latitude],
    },
  };
  const mapContainerRef = useRef(null);
  const map = useRef();

  useEffect(() => {
    map.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/dark-v10",
      center: config.location?.center,
      zoom: 12,
    });

    const marker = new mapboxgl.Marker({ color: config.markerColor });
    marker.setLngLat(config.location.center).addTo(map.current);

    //     map.current.once("load", () => {
    //       map.current.zoomTo(17, { duration: 2000 });
    //     });
    // map.current.on('move', () => {
    //   setLng(map.current.getCenter().lng.toFixed(4));
    //   setLat(map.current.getCenter().lat.toFixed(4));
    //   setZoom(map.current.getZoom().toFixed(2));
    // });

    return () => map.current.remove();
  }, []);

  const parent = {
    initial: { y: 1800 },
    animate: {
      y: 0,
      transition: {
        staggerChildren: 0.5,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  const child = {
    initial: { y: 1800 },
    animate: {
      y: 0,
      transition: {
        duration: 1,
        ease: [0.6, 0.05, -0.01, 0.9],
      },
    },
  };

  return (
    <div className="w-100">
      <Styled.MapSidebar variants={parent} initial="initial" animate="animate">
        <Heading2 variants={child}>
          {slideType?.[0]?.title.toUpperCase()}
        </Heading2>
        <motion.div className="w-100 pb4" variants={child}>
          <Image
            className="w-75"
            src={slideType?.[0]?.image?.url}
            fallback={slideType?.[0]?.image?.url}
            mime={slideType?.[0]?.image?.mime}
            alt={slideType?.[0]?.image?.alternativeText}
          />
        </motion.div>
        <Paragraph variants={child}>{slideType?.[0]?.text}</Paragraph>
      </Styled.MapSidebar>
      <Styled.MapContainer ref={mapContainerRef} />
    </div>
  );
};

export default StoryWithImageAndMap;
